import React from "react";
import { useItems, useQuery } from "@findify/react-connect";
import SearchItems from "./SearchItems";
import SearchRecommendations from "./SearchRecommendations";
import classes from "./SearchResults.module.scss";
import { useMedia } from "../../hooks";
import clsx from "clsx";
import { Recommendation as RecommendationAgent } from '@findify/agent'
import { RecommendationProvider } from '@findify/react-connect/lib';

const config = {
    key: process.env.REACT_APP_FINDIFY_KEY,
    user: {
        uid: "uid",
        sid: "sid",
    },
    immutable: true,
    limit: 6,
    debounce: 100
};

const recommendationAgent = new RecommendationAgent(config);

const SearchResults = () => {
    const { query, meta } = useQuery()
    const { items } = useItems()

    const isMobile = useMedia('(max-width: 991.8px)');

    if (query.get("q") && items.size > 0) {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <h3 className={classes.label}>Top Results</h3>
                </div>
                <div className="col-xs-12">
                    <SearchItems />
                </div>
                <div className="col-xs-12">
                    <a href={`/search-results?q=${encodeURIComponent(query.get("q"))}`} className={clsx(classes.marginTop, {
                        [classes.link]: !isMobile,
                        'btn btn-primary btn-block': isMobile
                    })}>
                        View all results ({meta.get('total')})
					</a>
                </div>
            </div>
        );
    } else {
        return (
            <RecommendationProvider agent={recommendationAgent}>
                <div className="row">
                    <div className="col-xs-12">
                        <h3 className={classes.label}>Top Recommendations</h3>
                    </div>
                    <div className="col-xs-12">
                        <SearchRecommendations />
                    </div>
                </div>
            </RecommendationProvider>
        )
    }
}

export default SearchResults;
